export default {
  snackbarText: null,
  timeout: 1000,
  color: "success",
};
